import { render, staticRenderFns } from "./battle.vue?vue&type=template&id=295b5469&"
import script from "./battle.vue?vue&type=script&lang=js&"
export * from "./battle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports